import '@autocut/designSystem/styles/index';
import {useEffect, useState} from 'react';

import styles from './App.module.scss';
import BackgroundBlurCircles from './components/common/BackgroundBlurCircles/BackgroundBlurCircles';
import {LoadingPing} from './components/LoadingPing/LoadingPing';
import {useOutput} from './contexts/OutputContext';
import {Button} from './designSystem/components/atoms/Button/Button';
import {Text} from './designSystem/components/atoms/Text/Text';
import {FormSection} from './designSystem/components/layout/FormSection/FormSection';
import {CustomChecks} from './sections/CustomChecks/CustomChecks';
import {Pings} from './sections/Pings';
import {waitForPreload} from './types/ElectronPreload';
import {documentClick} from './utils/observers';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const {output, copyOutput} = useOutput();

  useEffect(() => {
    void (async () => {
      await waitForPreload();
      setIsLoading(false);
    })();
  }, []);

  return isLoading ? (
    <LoadingPing />
  ) : (
    <div
      className={styles.pageLayout}
      onClick={() => {
        // Used to close select inputs when clicked outside of the component
        documentClick.notify();
      }}
    >
      <BackgroundBlurCircles />
      <header className={styles.header}>
        <Text variant="displayXs.bold">AutoCut System Report</Text>
      </header>
      <div className={styles.output}>
        <Text variant="textSm.semibold">{output}</Text>
        <Button
          variant="secondary"
          onClick={copyOutput}
          fullWidth={false}
        >
          Copy
        </Button>
      </div>
      <div className={styles.body}>
        <FormSection title="Server check">
          <Pings />
        </FormSection>
        <FormSection title="Custom checks">
          <CustomChecks />
        </FormSection>
      </div>
    </div>
  );
}

export default App;
